/**
 * Used to wrap async/await code in a try/catch block. Returns an array with the error as the first element and null as the second element when the promise rejects. Returns an array with null as the first element and the data as the second element when the promise resolves successfully.
 *
 * @export
 * @template ValueType
 * @param {Promise<ValueType>} promise
 * @return {*}  {(Promise<[null, ErrorType] | [ValueType, null]>)}
 */
export async function to<ValueType = unknown, ErrorType = Error>(
	promise: Promise<ValueType>
): Promise<[null, ErrorType] | [ValueType, null]> {
	try {
		const data = await promise;
		return [data, null];
	} catch (err) {
		return [null, err as ErrorType];
	}
}
